export const LOGIN = '/api/auth/local';
export const USERS = '/api/users';
export const SHEEP = '/api/sheeps';
export const ROOMS = '/api/rooms';
export const SUMMARY = '/api/summary';
export const TAGS = '/api/tags';
export const BUSES = '/api/buses';
export const CAMP_CONFIG = '/api/camp-config';
